import { memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'

import { Menu } from '@headlessui/react'
import { UserManager } from '@app/managers'
import { classNames } from '@app/utils/classes'
import { routeParseAbsolute } from '@app/lib/router-handler'
import { btnStyles, getActiveStyles } from '../cells/menu/styles'
import { MenuList } from '../menu'
import { Link } from '@app/components/stateless/typo/link'

type AuthMenuComponentProps = {
  authenticated?: boolean // user logged in
  icon?: 'settings' | 'more' // display settings icon
  className?: string
  dashboard?: boolean // is this the dashboar dpage
}

// auth menu requires graphQL - TODO: logout item if authed
const AuthMenuComponentMock = ({
  icon,
  className,
  dashboard,
}: AuthMenuComponentProps) => {
  const { t, lang } = useTranslation('menu')

  return (
    <div className={className}>
      <MenuList
        settings={icon === 'settings'}
        more={icon === 'more'}
        dashboard={dashboard}
      >
        <div className='max-w-lg'>
          {UserManager.user.firstName ? (
            <div className='text-sm px-4 py-2 text-gray-800 dark:text-gray-100'>
              {UserManager.user.firstName + ' ' + UserManager.user.lastName}
            </div>
          ) : null}
          {UserManager.user.email ? (
            <div className='text-sm px-4 py-2 text-gray-700 dark:text-gray-200 truncate'>
              {UserManager.user.email}
            </div>
          ) : null}
        </div>
        <Menu.Item>
          {({ active }) => (
            <Link
              href={routeParseAbsolute('/login', lang)}
              className={classNames(btnStyles, getActiveStyles(active))}
              shouldPrefetch={false}
            >
              {t('common:login')}
            </Link>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <Link
              href={routeParseAbsolute('/register', lang)}
              className={classNames(
                btnStyles,
                getActiveStyles(active),
                'border-t'
              )}
              shouldPrefetch={false}
            >
              {t('common:register')}
            </Link>
          )}
        </Menu.Item>
      </MenuList>
    </div>
  )
}

export const AuthMenuMock = memo(AuthMenuComponentMock)
